/**
 * isPC
 * @author marvinqi
 * @createTime 2017/9/20
 */
import toNum from '../../../utils/toNum'
import _platform from './platform'
export default function () {
  return !toNum(_platform('os ')) && !toNum(_platform('android[/ ]'))
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isPC.js